/** Texto fijo PK Decla (desde fila ~35 en plantilla Excel); solo cambia date of issue. */

import { PK_DECLA_STATIC_TEMPLATE_BASE } from './pkDeclaLayout';

export const PK_DECLA_COMPANY_LINES = [
  'PALM TRADE CHILE SPA',
  'Avenida Presidente Kennedy 5146 oficina 51',
  'Vitacura, Santiago, Chile',
  'Fono : (56-2) 22190119 - Fax : (56-2) 2 2184390',
];

export const PK_DECLA_TITLE = 'FCL PACKING DECLARATION';

export const PK_DECLA_SIGNATURE = 'PALM TRADE CHILE';

/**
 * @typedef {{ type: 'text', value: string, tall?: boolean, gapAfter?: number }}
 *          | {{ type: 'qa', question: string, answerLeft: string, answerRight: string, gapAfter?: number }}
 *          | {{ type: 'pair', left: string, right: string, gapAfter?: number }} PkDeclaStaticItem
 */

/** @type {PkDeclaStaticItem[]} */
export const PK_DECLA_STATIC_ITEMS = [
  {
    type: 'text',
    value:
      'PROHIBITED PACKAGING MATERIAL STATEMENT (prohibited packaging materials include straw, bamboo, peat, hay, chaff, used fruit and vegetable cartons etc.)',
    tall: true,
  },
  {
    type: 'qa',
    question:
      'Q1. Have prohibited packaging materials or bamboo products been used as packaging or dunnage in the consignment covered by this document?',
    answerLeft: ' A1.  YES',
    answerRight: 'NO  X',
  },
  {
    type: 'text',
    value:
      'TIMBER PACKAGING/DUNNAGE STATEMENT (Timber packaging/dunnage includes: crates, cases, pallets, skids, and any other timber (solid & plywood) used as a shipping aid.)',
    tall: true,
  },
  {
    type: 'qa',
    question: 'Q2a. Has Timber packaging/dunnage been used in consignments covered by this documents?',
    answerLeft: 'A2a. YES',
    answerRight: 'NO  X ',
  },
  { type: 'text', value: 'ISPM15 STATEMENT' },
  {
    type: 'qa',
    question:
      'Q2b. All timber packaging/dunnage used in the consignment has been treated and marked in compliance with ISPM 15? ( ISPM 15 does not apply to plywood or veneer).',
    answerLeft: 'A2b. YES',
    answerRight: 'NO  ',
  },
  {
    type: 'text',
    value: 'If Plywood packaging has been used, is a treatment certificate available.',
  },
  {
    type: 'pair',
    left: 'A2b  YES- X …Fumigate Certificate     ',
    right: 'NO',
  },
  {
    type: 'text',
    value:
      'BARK STATEMENT (This is also applicable to ISPM 15 compliant packaging/dunnage. Bark is the external natural layer covering trees and branches)',
    tall: true,
  },
  {
    type: 'qa',
    question: 'Q3. Is all timber packaging/dunnage used in this consignment free from bark?',
    answerLeft: 'A3. YES',
    answerRight: 'NO',
  },
  {
    type: 'text',
    value:
      'CLEANLINESS DECLARATION (For FCL consignments only) The container(s) covered by this document has/have benn cleaned and is/are free from material of animal and/or plant origin and soil',
    tall: true,
  },
];

const STATIC_ALIGN = { horizontal: 'left', vertical: 'top' };

/** Alturas (pt) bloque legal — suficiente para wrap sin cortar en carta. */
const H_TALL_PAIR = [15, 14];
const H_STATEMENT = 13;
const H_QUESTION_PAIR = [12, 11.5];
const H_QUESTION_SINGLE = 15;
const H_ANSWER = 11;
const H_PAIR_ROW = 11;

/** Filas “respiración” entre bloques (37, 41, …) en plantilla base 35. */
const STATIC_SPACER_ROWS = [37, 41, 44, 46, 48, 50, 54, 56, 58, 62, 66];

/**
 * Bloque legal (misma estructura que plantilla); {@param staticStartRow} se desplaza si hay muchos contenedores.
 */
export function writePkDeclaStaticBlockFixed(ws, helpers, staticStartRow = PK_DECLA_STATIC_TEMPLATE_BASE) {
  const { mergeBlock, writePair, setRowHeight } = helpers;
  const items = PK_DECLA_STATIC_ITEMS;
  const at = (templateRow) => templateRow + (staticStartRow - PK_DECLA_STATIC_TEMPLATE_BASE);

  STATIC_SPACER_ROWS.forEach((row) => setRowHeight(at(row), 8.25));

  const tall2 = (r, text, h1 = H_TALL_PAIR[0], h2 = H_TALL_PAIR[1]) => {
    mergeBlock(r, 1, r + 1, 6, text, { align: STATIC_ALIGN });
    setRowHeight(r, h1);
    setRowHeight(r + 1, h2);
  };
  const oneLine = (r, text, h = H_STATEMENT) => {
    mergeBlock(r, 1, r, 6, text, { align: STATIC_ALIGN });
    setRowHeight(r, h);
  };
  const question2 = (rQ, rA, qa) => {
    mergeBlock(rQ, 1, rQ + 1, 6, qa.question, { align: STATIC_ALIGN });
    setRowHeight(rQ, H_QUESTION_PAIR[0]);
    setRowHeight(rQ + 1, H_QUESTION_PAIR[1]);
    writePair(rA, qa.answerLeft, qa.answerRight);
    setRowHeight(rA, H_ANSWER);
  };
  const question1 = (rQ, rA, qa) => {
    mergeBlock(rQ, 1, rQ, 6, qa.question, { align: STATIC_ALIGN });
    setRowHeight(rQ, H_QUESTION_SINGLE);
    writePair(rA, qa.answerLeft, qa.answerRight);
    setRowHeight(rA, H_ANSWER);
  };

  tall2(at(35), items[0].value);
  question2(at(38), at(40), items[1]);
  tall2(at(42), items[2].value);
  question1(at(45), at(47), items[3]);
  oneLine(at(49), items[4].value);
  question2(at(51), at(53), items[5]);
  oneLine(at(55), items[6].value);
  writePair(at(57), items[7].left, items[7].right);
  setRowHeight(at(57), H_PAIR_ROW);
  tall2(at(59), items[8].value);
  question1(at(61), at(63), items[9]);
  tall2(at(64), items[10].value);
}
